import USBButton from '@usb-shield/react-button'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { BASE_PATH } from '../../../config/connections'
// import { systemErrorCache } from '../../../graphql/cache/localCache'
import sopLogo from '../../../images/robot.svg'
import { useMultilingualService } from '../../../service/multilingualService'
import { isOLBApp } from '../../../utils/browserutils'
import { systemErrorCache } from '../../../context/appCache'

/**
 * Error Component
 *
 *
 * @returns {HTMLElement}
 */

export default function ErrorComponent() {
  const navigate = useNavigate()
  const { SYSTEMNOTCOOPERATING, SORRYERROR, TRY_AGAIN } =
    useMultilingualService('error')

  const {
    // status = false,
    title = '',
    errorMsg = '',
    CTA = '',
    isRecoverable = false
  } = systemErrorCache() || {}

  /* Check onboardingDeeplink */
  let fromOnboarding = false
  const onboardingDeeplink = JSON.parse(
    sessionStorage.getItem('onboardingBillpayDeeplink')
  )
  if (
    onboardingDeeplink &&
    onboardingDeeplink?.source === 'digitalOnboarding'
  ) {
    fromOnboarding = true
  }
  useEffect(
    () => () => {
      systemErrorCache({})
    },
    []
  )
  const handleCloseClick = () => {
    if (fromOnboarding && onboardingDeeplink) {
      window.location.href = `${onboardingDeeplink.redirectUrl}/billpay`
    } else if (CTA === 'Call 800-872-2657') {
      window.open(`tel:${CTA}`, '_self')
    } else if (!isRecoverable) {
      navigate(BASE_PATH)
    } else navigate(-1)
  }

  return (
    <>
      <div
        data-testId="detailserror"
        style={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <p
          style={{
            color: '#0c2074',
            margin: '1.935rem auto',
            maxWidth: '25.81rem'
          }}
          className="usb-tg-display-small"
        >
          {title || SYSTEMNOTCOOPERATING}
        </p>
        <p
          style={{
            color: '#2C2C2C',
            marginBottom: '1.5rem'
          }}
          className="usb-tg-body-small"
        >
          {errorMsg || SORRYERROR}
        </p>
        <img
          src={sopLogo}
          alt="loader"
          style={{
            height: '14.375rem',
            marginBottom: '1.935rem'
          }}
        />
        <USBButton
          variant="primary"
          id="error-close"
          size={isOLBApp() ? 'default' : 'large'}
          // handleClick={() => navigate(-1)}
          handleClick={handleCloseClick}
          ariaLabel={CTA || TRY_AGAIN}
        >
          {CTA || TRY_AGAIN}
        </USBButton>
      </div>
    </>
  )
}
